/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-ignore:next-line
function _defineProperties(target, props) {
    for (let i = 0; i < props.length; i++) {
        const descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
// @ts-ignore:next-line
function _setPrototypeOf(o, p) {
    // eslint-disable-next-line no-func-assign,@typescript-eslint/ban-ts-comment
    // @ts-ignore
    _setPrototypeOf =
        Object.setPrototypeOf ||
            // @ts-ignore:next-line
            function _setPrototypeOf(o, p) {
                // eslint-disable-next-line no-proto
                o.__proto__ = p;
                return o;
            };
    return _setPrototypeOf(o, p);
}
// @ts-ignore:next-line
function _assertThisInitialized(self) {
    // eslint-disable-next-line no-void
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    }
    catch (e) {
        return false;
    }
}
// @ts-ignore:next-line
function _getPrototypeOf(o) {
    // eslint-disable-next-line no-func-assign,@typescript-eslint/ban-ts-comment
    // @ts-ignore
    _getPrototypeOf = Object.setPrototypeOf
        ? Object.getPrototypeOf
        : function _getPrototypeOf(o) {
            // eslint-disable-next-line no-proto
            return o.__proto__ || Object.getPrototypeOf(o);
        };
    return _getPrototypeOf(o);
}
// @ts-ignore:next-line
function _typeof(obj) {
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        // eslint-disable-next-line no-func-assign,@typescript-eslint/ban-ts-comment
        // @ts-ignore
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    }
    else {
        // eslint-disable-next-line no-func-assign,@typescript-eslint/ban-ts-comment
        // @ts-ignore
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype
                ? 'symbol'
                : typeof obj;
        };
    }
    return _typeof(obj);
}
// @ts-ignore:next-line
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
        // eslint-disable-next-line no-void
    }
    else if (call !== void 0) {
        throw new TypeError('Derived constructors may only return object or undefined');
    }
    return _assertThisInitialized(self);
}
// @ts-ignore:next-line
export function defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true,
        });
    }
    else {
        obj[key] = value;
    }
    return obj;
}
// @ts-ignore:next-line
export function createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
// @ts-ignore:next-line
export function inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: { value: subClass, writable: true, configurable: true },
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
// @ts-ignore:next-line
export function createSuper(Derived) {
    const hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        const Super = _getPrototypeOf(Derived);
        let result;
        if (hasNativeReflectConstruct) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const NewTarget = _getPrototypeOf(this).constructor;
            // eslint-disable-next-line prefer-rest-params
            result = Reflect.construct(Super, arguments, NewTarget);
        }
        else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            result = Super.apply(this, arguments);
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return _possibleConstructorReturn(this, result);
    };
}
